import { ValidatorFn, Validators } from "@angular/forms";

export const URL_REGEX = RegExp(/^https:\/\/?([a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,20})(:[0-9]{1,5})?(\/.*)?$/);

export const BASE_URL_VALIDATORS: ValidatorFn[] = [Validators.pattern(URL_REGEX), Validators.maxLength(2000)];
